import { authSaga } from "views/auth/sagas/authSaga";
import { meSaga } from "views/auth/sagas/meSaga";
import { all } from "redux-saga/effects";
import brandSaga from "views/superuser/brand/saga/brandSaga";
import userSaga from "views/superuser/user/sagas/userSaga";
import storeSaga from "views/superuser/stores/saga/storeSaga";
import platformSaga from "views/superuser/platform/saga/platformSaga";
import activitylogSaga from "views/superuser/activitylog/saga/activitylogSaga";
import paymentSaga from "views/superuser/payment/sagas/paymentSaga";
import invoiceSaga from "views/superuser/invoice/sagas/inVoiceSaga";
import subscriptionSaga from "views/superuser/Subscriptions/sagas/subscriptionSaga";
import brandLocationSaga from "views/superuser/BrandLocatioManage/sagas/brandLocationSaga";
import notificationSaga from "views/superuser/notification/sagas/notificationSaga";
import adminManageSaga from "views/superuser/adminmanage/saga/adminManageSaga";
import generalSettingSaga from "views/superuser/generalSetting/saga/generalSettingSaga";
import documentSaga from "views/superuser/documentManage/sagas/documentSaga";
import assignPlatformSaga from "views/superuser/platformAssign/saga/platformAssignSaga";
import customersSaga from "views/superuser/customers/saga/customersSaga";
import packageSaga from "views/superuser/packagemanage/sagas/packageSaga";
import accessRoleSaga from "views/superuser/accessRole/saga/accessRoleSaga";
import couponManageSaga from "views/superuser/couponmanage/sagas/couponManageSaga";
import couponUsageSaga from "views/superuser/couponUsage/saga/couponUsageSaga";
import roleModuleSaga from "views/superuser/rolemodule/sagas/roleModuleSaga";
import dashBoardSaga from "views/superuser/dashboard/saga/dashBoardSaga";
import statementSaga from "views/superuser/statement/sagas/statementSaga";
import enumSaga from "views/superuser/enumConfiguration/sagas/enumSaga";
import groupSaga from "views/superuser/group/saga/groupSaga";
import inquirySaga from "views/superuser/inquiry/saga/inquirySaga";
import adminUserMgmtAdminUsersSaga from "views/superuser/adminUserManagement/sagas/adminUsersSaga";
import adminUserMgmtAccessRoleSaga from "views/superuser/adminUserManagement/sagas/accessRoleSaga";
import adminUserMgmtPermissionSaga from "views/superuser/adminUserManagement/sagas/permissionSaga";
import { kotSaga } from "views/superuser/brand/saga/kotSaga";
import { deviceSaga } from "views/superuser/brand/saga/deviceSaga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    meSaga(),
    brandSaga(),
    userSaga(),
    storeSaga(),
    platformSaga(),
    activitylogSaga(),
    paymentSaga(),
    invoiceSaga(),
    groupSaga(),
    enumSaga(),
    subscriptionSaga(),
    brandLocationSaga(),
    documentSaga(),
    notificationSaga(),
    adminManageSaga(),
    generalSettingSaga(),
    assignPlatformSaga(),
    customersSaga(),
    packageSaga(),
    accessRoleSaga(),
    couponManageSaga(),
    couponUsageSaga(),
    roleModuleSaga(),
    dashBoardSaga(),
    statementSaga(),
    inquirySaga(),
    adminUserMgmtAdminUsersSaga(),
    adminUserMgmtAccessRoleSaga(),
    adminUserMgmtPermissionSaga(),
    kotSaga(),
    deviceSaga(),
  ]);
}
